import { isWithinInterval } from 'date-fns';

import DatePickerWidgetContent from '@components/date-picker/DatePickerWidgetContent';
import { dateFromStr } from '@utils';

export const getClicksWarningContent = (sponsoredDisplayCost, dateRange) => {
  // https://bitbucket.org/rf0tech/sm_server/pull-requests/3305/diff
  if (!sponsoredDisplayCost) return null;
  const affectedInterval = { start: dateFromStr('2025-02-01'), end: dateFromStr('2025-06-30') };
  const { from, to } = dateRange;
  if (isWithinInterval(from, affectedInterval) || isWithinInterval(to, affectedInterval)) {
    return (
      <div className="">
        <div>Sponsored Display clicks unavailable for</div>
        <DatePickerWidgetContent
          range={{ from: affectedInterval.start, to: affectedInterval.end }}
          today={new Date()}
        />
      </div>
    );
  }
  return null;
};
